



<template>
    <div v-if="view" class="fixed bottom-0 right-0 w-full max-w-lg z-[2000000] p-4">
        <div class="bg-white dark:bg-neutral-900 dark:border dark:border-primary rounded-lg shadow-2xl p-4">
            <div class="flex items-center justify-between mb-2">
                <div class="flex items-center">
                    <svg-vue class="w-6 h-6 mr-2" :icon="'cookie'"></svg-vue>
                    <span class="text-gray-700 dark:text-primary font-bold text-sm">{{ $t("Cookie Policy") }}</span>
                </div>
            </div>
            <p class="text-gray-600 dark:text-white text-sm">
                {{ $t("To provide the best experiences, we use technologies like cookies to store and/or access device information.Consenting to these technologies will allow us to process data such as browsing behaviour or unique IDs on this site.") }}</br>
                {{ $t('For more information please look at our') }} <a class="text-primary" :href="$attrs.cookie_url">
                    {{ $t('Cookie Policy') }}</a>
            </p>
            <div class="flex justify-between">
                <button @click="Reject"
                    class="mt-4 bg-primary hover:scale-95 transition text-white dark:text-white font-bold py-2 px-4 rounded">
                    {{ $t('Reject') }}
                </button>
                <button @click="Accept"
                    class="mt-4 bg-primary hover:scale-95 transition text-white dark:text-white font-bold py-2 px-4 rounded">
                    {{ $t('Accept') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies';

export default {
    data() {
        return {
            view: false
        }
    },
    methods: {
        Accept() {
            gtag('consent', 'update', {
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'ad_storage': 'granted',
                'analytics_storage': 'granted'
            });
            
            VueCookies.set('cookie_accepted', true, '30d')
            this.view = false;
        },
        Reject() {
            gtag('consent', 'update', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied'
            });
            VueCookies.set('cookie_accepted', false, '30d')
            this.view = false;
        }
    },
    created() {
        if (!VueCookies.get('cookie_accepted')) {

            gtag('consent', 'default', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied'
            });
            this.view = true;
        } else {
            gtag('consent', 'default', {
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'ad_storage': 'granted',
                'analytics_storage': 'granted'
            });
        }
    }
}
</script>